import angular from 'angular';
import { cloneDeep, get } from 'lodash';
import '../../components/osom';
import '../../services/errors';

const module = angular.module('whyline.modals.organization-information-screen', [
  'whyline.components.osom',
  'whyline.services.errors',
  'whyline.services.organization-information-screen',
]);

const OrganizationInformationScreenModalController = (
  $scope,
  $timeout,
  $translate,
  $uibModalInstance,
  currentOrganization,
  ErrorService,
  organizationInformationScreenId,
  OrganizationInformationScreenService,
  NotificationService,
) => {
  'ngInject';

  $scope.blockSaveButton = false;
  $scope.organizationInformationScreen = {
    button: {
      label: '',
      url: '',
    },
    isActive: true,
    label: '',
    messages: {
      kiosk: '',
      mobileApp: '',
      reception: '',
      agenda: '',
    },
    type: 'organization-information-screen',
  };
  const namePattern = /^[ '-:A-Za-z\xC0-\xCF\xD1-\xD6\xD8-\xDD\xDF-\xE5\xE7-\xF6\xF8-\xFD\xFF\u0104-\u0107\u010C\u010D\u0116-\u0119\u012E\u012F\u0141-\u0144\u0152\u0160\u0161\u016A\u016B\u0172\u0173\u0178-\u017E]+$/i;
  const urlPattern = /(https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9][a-zA-Z0-9-]+[a-zA-Z0-9]\.[^\s]{2,}|https?:\/\/(?:www\.|(?!www))[a-zA-Z0-9]\.[^\s]{2,}|www\.[a-zA-Z0-9]\.[^\s]{2,})/i;

  const getOrganizationInformationScreen = (id) =>
    OrganizationInformationScreenService.GetOneAsPromise(id).then(
      (organizationInformationScreen) => {
        $scope.organizationInformationScreen = cloneDeep(organizationInformationScreen);
      },
  );

  if (organizationInformationScreenId) {
    getOrganizationInformationScreen(organizationInformationScreenId);
  }

  const validateLabel = (value) => {
    if (!value) {
      NotificationService.Warning(
        $translate.instant('organization-information-screens-name-mandatory'),
      );
      return false;
    }

    if (value.length < 2 || value.length > 50) {
      NotificationService.Warning(
        $translate.instant('organization-information-screens-name-max-length'),
      );
      return false;
    }

    if (!namePattern.test(value)) {
      NotificationService.Warning($translate.instant('char_forbidden_name'));
      return false;
    }

    return true;
  };

  const validateMessages = (messages) => {
    const kioskMessage = get(messages, 'kiosk', '');
    const mobileAppMessage = get(messages, 'mobileApp', '');
    const receptionMessage = get(messages, 'reception', '');
    const agendaMessage = get(messages, 'agenda', '');

    if (!kioskMessage) {
      NotificationService.Warning($translate.instant('message-kiosk-mandatory'));
      return false;
    }

    if (kioskMessage.length > 300) {
      NotificationService.Warning($translate.instant('message-kiosk-max-length'));
      return false;
    }

    if (!mobileAppMessage) {
      NotificationService.Warning($translate.instant('message-mobile-app-mandatory'));
      return false;
    }

    if (mobileAppMessage.length > 300) {
      NotificationService.Warning($translate.instant('message-mobile-app-max-length'));
      return false;
    }

    if (!receptionMessage) {
      NotificationService.Warning($translate.instant('message-reception-mandatory'));
      return false;
    }

    if (receptionMessage.length > 300) {
      NotificationService.Warning($translate.instant('message-reception-max-length'));
      return false;
    }

    if (!agendaMessage) {
      NotificationService.Warning($translate.instant('message-agenda-mandatory'));
      return false;
    }

    if (agendaMessage.length > 1000) {
      NotificationService.Warning($translate.instant('message-agenda-max-length'));
      return false;
    }

    return true;
  };

  const validate = () => {
    const buttonLabel = get($scope.organizationInformationScreen, 'button.label', '');
    const buttonUrl = get($scope.organizationInformationScreen, 'button.url', '');

    if (!validateLabel(get($scope.organizationInformationScreen, 'label', ''))) {
      return false;
    }

    if (!validateMessages($scope.organizationInformationScreen.messages)) {
      return false;
    }

    if (buttonLabel && !buttonUrl) {
      NotificationService.Warning($translate.instant('button-url-mandatory'));
      return false;
    }

    if (!buttonLabel && buttonUrl) {
      NotificationService.Warning($translate.instant('button-label-mandatory'));
      return false;
    }

    if (buttonLabel && buttonUrl) {
      if (buttonLabel.length > 22) {
        NotificationService.Warning($translate.instant('button-label-max-length'));
        return false;
      }

      if (!urlPattern.test(buttonUrl)) {
        NotificationService.Warning($translate.instant('button-url-invalid'));
        return false;
      }
    }

    return true;
  };

  $scope.close = () => {
    $uibModalInstance.close();
  };

  if (organizationInformationScreenId) {
    OrganizationInformationScreenService.GetOneAsPromiseFromServer(organizationInformationScreenId)
      .then((organizationInformationScreen) => {
        $timeout(() => {
          $scope.organizationInformationScreen = OrganizationInformationScreenService.Copy(
            organizationInformationScreen,
          );
        });
      })
      .catch((error) => {
        $scope.blockSaveButton = false;
        ErrorService.handler(error);
      });
  }

  $scope.save = () => {
    $scope.organizationInformationScreen.organizationId = currentOrganization._id;

    if (validate()) {
      $scope.blockSaveButton = true;

      if (organizationInformationScreenId) {
        return OrganizationInformationScreenService.Update($scope.organizationInformationScreen)
          .then(() => {
            NotificationService.Success(
              $translate.instant('organization-information-screens-update-succ'),
            );
            $uibModalInstance.close('cancel');
          })
          .catch((error) => {
            $scope.blockSaveButton = false;
            ErrorService.handler(error);
          });
      }

      return OrganizationInformationScreenService.Create($scope.organizationInformationScreen)
        .then(() => {
          NotificationService.Success(
            $translate.instant('organization-information-screens-create-succ'),
          );
          $uibModalInstance.close('cancel');
        })
        .catch((error) => {
          $scope.blockSaveButton = false;
          ErrorService.handler(error);
        });
    }
  };
};

module.exports = module.controller(
  'OrganizationInformationScreenModalController',
  OrganizationInformationScreenModalController,
);
